import React, { useState } from 'react';
import { precepts } from '../../onboardingContent';
import { logEvent } from '../../lib/analytics';

export default function PreceptCheck() {
  const [agreements, setAgreements] = useState({});

  const toggle = (key) => {
    const updated = { ...agreements, [key]: !agreements[key] };
    setAgreements(updated);
    logEvent('precepts_toggle', { key, value: updated[key] });
  };

  const allChecked = precepts.every(p => agreements[p.key]);

  const handleAccept = () => {
    logEvent('precepts_accept', agreements);
    alert('Thank you for taking the pledge!');
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Precept Pledge</h2>
      {precepts.map(p => (
        <div key={p.key} className="form-check mb-3">
          <input
            id={p.key}
            type="checkbox"
            className="form-check-input"
            checked={!!agreements[p.key]}
            onChange={() => toggle(p.key)}
          />
          <label htmlFor={p.key} className="form-check-label">
            <strong>{p.title}</strong> <em>({p.verse})</em>
            <div>{p.summary}</div>
          </label>
        </div>
      ))}
      <button className="btn btn-warning" disabled={!allChecked} onClick={handleAccept}>
        Accept
      </button>
    </div>
  );
}
